<template>
  <div class="content-container">
    <search-comp @onSearch="attachData" @onReset="onReset">
      <div class="das-form-container">
        <div class="das-form-group">
          <div class="das-form-row">
            <div class="das-form-col col-3">
              <div class="checkbox-container">
                <div class="checkbox-wrap">
                  <input
                    id="cpSpdTp30"
                    v-model="searchParams.isParent"
                    type="checkbox"
                  />
                  <label for="cpSpdTp30">Là cha</label>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </search-comp>
    <div v-loading="loading" class="grid-scroll">
      <GridEnterprise
        ref="agGrid"
        :columns="columnDefs"
        dom-layout="scroll"
        :group-grid="true"
        :tree-data="true"
        :auto-group-column-def="autoGroupColumnDef"
        :group-use-entire-row="false"
        :get-data-path="getDataPath"
        :rows="rows"
        class="agGrid"
        @selectionChanged="onSelectionChanged"
      />
      <!-- <GridVx
        ref="agGrid"
        :columns="columns"
        :auto-size-cell="true"
        dom-layout="scroll"
        :rows="rows"
        class="agGrid"
        @refresh="onRefresh"
      /> -->
    </div>
    <div class="button-containers mb-0">
      <button
        :disabled="selectedRows.length !== 1"
        class="btn primary small outline"
        @click="deleteWarehouse"
      >
        {{ $t('button.delete') }}
      </button>
      <button
        :disabled="selectedRows.length !== 1"
        class="btn primary small"
        @click="editWarehouse"
      >
        {{ $t('button.modify') }}
      </button>
      <button class="btn primary small" @click="openDialog">
        {{ $t('button.add') }}
      </button>
    </div>
    <el-dialog
      :title="
        isEdit
          ? $t('dialog.titleWarehouseUpdate')
          : $t('dialog.titleWarehouseAdd')
      "
      :visible.sync="dialogFormVisible"
      :close-on-click-modal="false"
      width="500px"
    >
      <validation-observer ref="formValidator">
        <div class="das-form-container">
          <div class="das-form-group">
            <div class="das-form-row">
              <div class="das-form-col col-6">
                <div class="das-form-input">
                  <div class="label">{{ $t('dialog.parentWarehouse') }}:</div>
                  <el-select v-model="submitForm.p_id" placeholder="">
                    <el-option
                      v-for="item in parentWarehouseOptions"
                      :key="item.id"
                      :disabled="isParentSelected"
                      :label="item.name"
                      :value="item.id"
                    >
                    </el-option>
                  </el-select>
                </div>
              </div>
              <div class="das-form-col col-6">
                <validation-provider rules="required|max:20" name="Mã">
                  <div class="das-form-input">
                    <div class="label required">{{ $t('dialog.code') }}:</div>
                    <div>
                      <input v-model="submitForm.code" type="text" />
                    </div>
                  </div>
                </validation-provider>
              </div>
            </div>
            <div class="das-form-row">
              <div class="das-form-col col-6">
                <validation-provider
                  rules="required|max:50"
                  name="Tên tiếng Việt"
                >
                  <div class="das-form-input">
                    <div class="label required">{{ $t('dialog.viName') }}:</div>
                    <div class="child-w-80">
                      <input v-model="submitForm.name" type="text" />
                    </div>
                  </div>
                </validation-provider>
              </div>
              <div class="das-form-col col-6">
                <validation-provider
                  rules="required|max:50"
                  name="Tên tiếng Anh"
                >
                  <div class="das-form-input">
                    <div class="label required">{{ $t('dialog.enName') }}:</div>
                    <div>
                      <input v-model="submitForm.eng_name" type="text" />
                    </div>
                  </div>
                </validation-provider>
              </div>
            </div>
          </div>
        </div>
      </validation-observer>
      <span slot="footer" class="dialog-footer">
        <div class="button-containers">
          <button
            class="btn primary small outline"
            @click="dialogFormVisible = false"
          >
            {{ $t('button.cancel') }}
          </button>
          <button
            v-if="isEdit"
            class="btn primary small"
            @click="updateWarehouse"
          >
            {{ $t('button.update') }}
          </button>
          <button v-else class="btn primary small" @click="addTax">
            {{ $t('button.create') }}
          </button>
        </div>
      </span>
    </el-dialog>
  </div>
</template>

<script>
/* eslint-disable */
import bus from '@/utils/bus'
import {
  getListWarehouseApi,
  addWarehouseApi,
  updateWarehouseApi,
  deleteWarehouseApi
} from '@/api/configuration/warehouse/list.js'
import { Message } from 'element-ui'
export default {
  data() {
    return {
      selectedRows: [],
      isParentSelected: false,
      loading: false,
      autoGroupColumnDef: null,
      parentWarehouseOptions: [],
      columnDefs: null,
      rows: [],
      isEdit: false,
      dialogFormVisible: false,
      searchParams: {
        isParent: false
      },
      submitForm: {
        p_id: null,
        code: null,
        name: '',
        eng_name: null
      }
    }
  },
  watch: {
    dialogFormVisible() {
      this.dialogFormVisible ? null : this.resetInfo()
    }
  },
  beforeMount() {
    this.context = { componentParent: this }
    this.columnDefs = [
      {
        headerName: this.$t('grid.column.name'),
        field: 'name',
        tooltipField: 'name'
      }
    ]
    this.autoGroupColumnDef = {
      headerName: this.$t('grid.column.code'),
      field: 'code',
      width: 100
      // headerCheckboxSelection: true,
      // cellRendererParams: {
      // checkbox: false,
      // innerRenderer: true,
      // minWidth: 300,
      // suppressCount: true
      // suppressCount: true,
      // checkbox: (params) => {
      //   return params.node.level === 0
      // },
      // innerRenderer: (params) => {
      //   return params.data.package_code
      // }
      // }
    }
    this.getDataPath = data => {
      return data.eng_name
    }
  },
  mounted() {
    this.attachData()
  },
  methods: {
    onSelectionChanged(rows) {
      this.selectedRows = rows
    },
    flattenNestedArray(arr, parentCodes = []) {
      return arr.flatMap(item => {
        const currenCodes = [...parentCodes, item.code]
        const flattenedItem = {
          p_id: item.p_id,
          eng_name: currenCodes,
          id: item.id,
          name: item.name,
          code: item.code
        }

        if (item.child) {
          return [
            flattenedItem,
            ...this.flattenNestedArray(item.child, currenCodes)
          ]
        } else {
          return [flattenedItem]
        }
      })
    },
    async getParentWarehouseOptions() {
      const data = await getListWarehouseApi({ isParent: true })
      this.parentWarehouseOptions = data.data
    },
    onReset() {
      this.searchParams.isParent = false
      this.attachData()
    },
    onRefresh(data) {
      let params = {
        orderBy: data.orderBy,
        orderTp: data.sort
      }
      this.searchParams = { ...this.searchParams, ...params }
      this.attachData()
    },
    resetInfo() {
      this.isEdit = false
      this.isParentSelected = false
      this.$nullValueInObj(this.submitForm)
    },
    openDialog() {
      this.dialogFormVisible = true
    },
    // CRUD
    async addTax() {
      if ((await this.$vxForm.isValid(this.$refs.formValidator)) === false) {
        return
      }
      let data = await addWarehouseApi(this.submitForm)
        .then(async res => {
          const message = res.message
          await this.attachData()
          this.dialogFormVisible = false
          this.$message({
            type: 'success',
            message: this.$t(`successMsg.${message}`)
          })
        })
        .catch(error => {
          const message = error.response?.data?.message || 'default'
          this.$message({
            type: 'error',
            message: this.$t(`errorMsg.${message}`)
          })
        })
    },
    editWarehouse() {
      const gridApi = this.$refs.agGrid.gridApi
      const row = gridApi.getSelectedRows()[0]
      if (!row) {
        this.$message({
          type: 'error',
          message: this.$t('errorMsg.selectRow')
        })
        return false
      }
      this.isEdit = true
      this.dialogFormVisible = true
      Object.assign(this.submitForm, row)
      if (this.submitForm.eng_name.length === 1) {
        this.isParentSelected = true
        this.submitForm.eng_name = row.eng_name[0]
      } else {
        this.submitForm.eng_name = row.eng_name[0]
      }
      // console.log('KIKI', row)
      // this.submitForm.p_id =
    },
    async deleteWarehouse() {
      const gridApi = this.$refs.agGrid.gridApi
      const row = gridApi.getSelectedRows()[0]
      if (!row) {
        this.$message({
          type: 'error',
          message: this.$t('errorMsg.selectRow')
        })
        return false
      }
      const id = row.id
      const id_list = []
      id ? id_list.push(id) : null
      if (id_list.length == 0) {
        this.$message({
          type: 'error',
          message: this.$t('errorMsg.selectRow')
        })
      } else {
        this.$vxConfirm(this.$t('alert.deleteWarehouseConfirm'), () => {
          deleteWarehouseApi({
            ids: id_list
          })
            .then(async res => {
              const message = res.message
              await this.attachData()
              this.dialogFormVisible = false
              this.$message({
                type: 'success',
                message: this.$t(`successMsg.${message}`)
              })
            })
            .catch(error => {
              const message = error.response?.data?.message || 'default'
              this.$message({
                type: 'error',
                message: this.$t(`errorMsg.${message}`)
              })
            })
        })
      }
    },
    async updateWarehouse() {
      if ((await this.$vxForm.isValid(this.$refs.formValidator)) === false) {
        return
      }
      let data = await updateWarehouseApi(this.submitForm)
        .then(async res => {
          const message = res.message
          await this.attachData()
          this.dialogFormVisible = false
          this.$message({
            type: 'success',
            message: this.$t(`successMsg.${message}`)
          })
        })
        .catch(error => {
          const message = error.response?.data?.message || 'default'
          this.$message({
            type: 'error',
            message: this.$t(`errorMsg.${message}`)
          })
        })
    },
    async attachData() {
      this.loading = true
      let data = await getListWarehouseApi(this.searchParams)
      this.getParentWarehouseOptions()
      this.loading = false
      this.rows = this.flattenNestedArray(data.data)
      this.selectedRows = []
    }
  }
}
</script>

<style lang="scss" scoped></style>
